<template>
  <WorkflowStep :step="step" :tab-data="templateTabs" :show-statuses="false" />
</template>

<script setup>
import toolbarTab from '@/utils/tabs/template-toolbar-tabs-enum';
import templateTabs from '@/utils/tabs/template-tabs-enum';

const step = toolbarTab.TEMPLATE_SCOPE_TAB;
</script>

<style lang="scss"></style>
